import axios from "axios";
import $ from "jquery";
const accommmodation_apiurl = process.env.VUE_APP_API_URL_ACCOMMODATION;

const state = {
  Accommodation: {},
  accommodationItemData: {},
};

const getters = {
  Accommodation(state) {
    return state.Accommodation;
  },
  accommodationItemData(state) {
    return state.accommodationItemData;
  },
};

const mutations = {
  setAccommodation(state, post) {
    state.Accommodation = post;
  },
  setAccommodationItemData(state, post) {
    state.accommodationItemData = post;
  },
};

const actions = {
  async createAccommodation({ rootState }, data) {
    const accessToken = rootState.authStore.token;

    return await axios.post(`${accommmodation_apiurl}/api/accom/create`, data, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
  },

  async updateAccommodation({ commit, rootState }, data) {
    const accessToken = rootState.authStore.token;

    return await axios.put(`${accommmodation_apiurl}/api/accom/update/${data.id}`, data.post, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
  },

  async deleteAccommodation({ dispatch, rootState }, id) {
    dispatch("showSpinnerLoading", null, { root: true });

    const accessToken = rootState.authStore.token;

    await axios
      .delete(`${accommmodation_apiurl}/api/accom/delete/${id}`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then(() => {
        $.alert("Accommodation has been deleted successfully");
        dispatch("hideSpinnerLoading", null, { root: true });
      });
  },

  async fetchAccommodationByName({ commit, rootState }, id) {
    const accessToken = rootState.authStore.token;

    return await axios
      .get(`${accommmodation_apiurl}/api/accom?id=${id}`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((res) => {
        commit("setAccommodationItemData", res.data);
      });
  },

  async fetchAccommodationAll({ commit, rootState }) {
    const accessToken = rootState.authStore.token;

    await axios
      .get(`${accommmodation_apiurl}/api/accom/all`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((res) => {
        commit("setAccommodation", res.data);
      });
  },

  async uploadAccommodationPhoto({ rootState }, formData) {
    const accessToken = rootState.authStore.token;

    return await axios.post(`${accommmodation_apiurl}/api/accom-upload`, formData, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        Accept: "application/json",
        "Content-Type": "multipart/form-data",
      },
      validateStatus: function (status) {
        return status < 500;
      },
    });
  },

  async deleteAccommPhoto({ rootState }, data) {
    const accessToken = rootState.authStore.token;

    await axios
      .delete(`${accommmodation_apiurl}/api/accom-photo/delete?url=${data.url}`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        validateStatus: function (status) {
          return status < 500;
        },
      })
      .then(() => {
        $.alert("Accommodation image deleted !");
      });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
